/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of segregation of duties constraints */
export enum SodConstraintType {
  Static,
  Dynamic,
  Temporal,
  Contextual,
}

export type SodConstraintTypeArgs = SodConstraintType;

export function getSodConstraintTypeEncoder(): FixedSizeEncoder<SodConstraintTypeArgs> {
  return getEnumEncoder(SodConstraintType);
}

export function getSodConstraintTypeDecoder(): FixedSizeDecoder<SodConstraintType> {
  return getEnumDecoder(SodConstraintType);
}

export function getSodConstraintTypeCodec(): FixedSizeCodec<
  SodConstraintTypeArgs,
  SodConstraintType
> {
  return combineCodec(
    getSodConstraintTypeEncoder(),
    getSodConstraintTypeDecoder(),
  );
}
